import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { pathData } from './path-data';

export interface ReemaLogoComponentProps extends SvgIconProps {
  useGradient?: boolean;
  gradientColors?: string[];
}

export const ReemaLogoComponent = ({
  useGradient = false,
  gradientColors,
  ...props
}: ReemaLogoComponentProps) => {
  let gradientArray = gradientColors;
  if (useGradient && !gradientColors) {
    gradientArray = ['#FF6B6B', '#4ECDC4'];
  }

  const viewBox = '0 0 2852 511';
  const gradientId = 'reemaLogoGradient';

  return (
    <SvgIcon {...props} viewBox={viewBox}>
      {useGradient && (
        <defs>
          <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
            {gradientArray.map((color, index) => {
              const offset =
                gradientArray.length === 1
                  ? 0
                  : (index * 100) / (gradientArray.length - 1);
              return (
                <stop key={index} offset={`${offset}%`} stopColor={color} />
              );
            })}
          </linearGradient>
        </defs>
      )}
      <path
        d={pathData}
        fill={useGradient ? `url(#${gradientId})` : 'currentColor'}
      />
    </SvgIcon>
  );
};
